export const MEETINGS_SCRIPT = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';

declare global {
  interface Window {
    hbspt?: { meetings?: { create?: (selector: string) => unknown } };
  }
}

export type BookingMessage = { booked: true; meetingAt: string | null };

/**
 * Parses the HubSpot scheduler's booking message. Only an exact origin from the
 * allowlist counts; a hostname merely ending in hubspot.com does not.
 */
export function parseBookingMessage(event: Pick<MessageEvent, 'origin' | 'data'>, allowedOrigins: string[]): BookingMessage | null {
  if (!allowedOrigins.includes(event.origin)) return null;
  const data = event.data as { meetingBookSucceeded?: unknown; meetingsPayload?: { bookingResponse?: { event?: { dateTime?: unknown } } } } | null;
  if (!data || typeof data !== 'object' || data.meetingBookSucceeded !== true) return null;
  const dateTime = data.meetingsPayload?.bookingResponse?.event?.dateTime;
  const meetingAt = typeof dateTime === 'number' && Number.isFinite(dateTime) ? new Date(dateTime).toISOString() : null;
  return { booked: true, meetingAt };
}

/**
 * Loads the Meetings embed script once. If it already ran before the container
 * existed, asks it to scan again; containers with an iframe are skipped.
 */
export function mountMeetingsEmbed(): void {
  const existing = document.querySelector<HTMLScriptElement>(`script[src="${MEETINGS_SCRIPT}"]`);
  if (existing) {
    window.hbspt?.meetings?.create?.('.meetings-iframe-container');
    return;
  }
  const script = document.createElement('script');
  script.src = MEETINGS_SCRIPT;
  script.async = true;
  document.body.appendChild(script);
}
